import { ReactNode } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';

import { sxStyles, StyledEmptyStateText, StyledNavigateLink } from './EmptyStateText.styles';

interface EmptyStateTextProps {
  title: string;
  icon?: ReactNode;
  subtitle?: string;
  buttonTitle?: string;
  buttonLink?: string;
}

export const EmptyStateText = (props: EmptyStateTextProps) => {
  const { icon, title, subtitle, buttonTitle, buttonLink } = props;

  return (
    <StyledEmptyStateText>
      {icon ? <CoreBox data-testid="icon">{icon}</CoreBox> : null}

      <CoreTypography data-testid="title" variant="h1">
        {title}
      </CoreTypography>

      {subtitle ? (
        <CoreTypography data-testid="subtitle" sx={sxStyles.subtitle}>
          {subtitle}
        </CoreTypography>
      ) : null}

      {buttonLink && buttonTitle ? (
        <StyledNavigateLink data-testid="navigateLink" to={buttonLink}>
          {buttonTitle}
        </StyledNavigateLink>
      ) : null}
    </StyledEmptyStateText>
  );
};
